import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {DatePickerInput, Toggle} from '@/components/atoms';
import {
  DATE_VALIDATION_TYPE,
  Constants
} from '@/utils/constants/commonConstants';

const PointsDeliverySection = ({
  formData,
  isMainTarget,
  onChange,
  salesTarget
}) => {
  // Check if editing In-Progress target
  const isInProgressTarget = useMemo(() => {
    return (
      salesTarget?.status &&
      salesTarget.status.toLowerCase() === Constants.InProgress.toLowerCase()
    );
  }, [salesTarget?.status]);

  const handleToggleChange = (val) => {
    // Prevent toggle change for In-Progress targets
    if (isInProgressTarget) return;
    onChange({...formData, awardPointsImmedFlag: val});
  };

  const handleDateChange = (val, validControl) => {
    onChange({
      ...formData,
      pointsDeliveryDate: val,
      pointsDeliveryDateValid: validControl
    });
  };

  return (
    <>
      {isMainTarget && (
        <div className='filters-partners'>
          <div className='display-second-row'>
            <Toggle
              value={!!formData?.awardPointsImmedFlag}
              updateValue={handleToggleChange}
              disabled={isInProgressTarget}
              uiSchema={{
                label: 'Award points immediately when goal hit?',
                isDark: true,
                showCheckedIcon: false
              }}
            />
          </div>
        </div>
      )}
      {!formData?.awardPointsImmedFlag && (
        <div className='z-15 relative mt-2'>
          <div className='filters-partners'>
            <div className='display-first-row'>
              <DatePickerInput
                value={formData?.pointsDeliveryDate}
                updateValue={handleDateChange}
                uiSchema={{
                  className: 'box-size-width z-9',
                  placeholder: 'Choose date',
                  label: 'Point Delivery Date*',
                  isDark: true,
                  menuPosition: 'top-left',
                  required: false,
                  dependentDate: formData?.targetDeliveryDate,
                  validationRules: [
                    {type: 'required', msg: ` is required`},
                    {
                      type: DATE_VALIDATION_TYPE.START_DATE,
                      msg: ` Point Delivery Date cannot be in the past.`,
                      excludeLabel: true
                    },
                    {
                      type: DATE_VALIDATION_TYPE.START_DATE_GREATER,
                      startDate: formData?.pointsDeliveryDate,
                      endDate: formData?.targetDeliveryDate,
                      msg: ' Point delivery date should be after target delivery date',
                      excludeLabel: true
                    }
                  ]
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

PointsDeliverySection.propTypes = {
  formData: PropTypes.object.isRequired,
  isMainTarget: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  salesTarget: PropTypes.object
};

export default React.memo(PointsDeliverySection);
